import { parseJson, oz } from '@weft/utils';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { GetLightInvoicesResponseSchema } from './get-light-invoice-response-schema';
import { GET_LIGHT_INVOICES_PATH } from './get-light-invoices-path';

const GET_LIGHT_INVOICES_QUERY_PARAM = {
  name: 'invoicesIds',
  location: 'query',
  schema: oz.string().transform(s => parseJson<string[]>(s)).pipe(oz.string().array()),
  required: true,
} as const satisfies ZapiParam;

export const GET_LIGHT_INVOICES_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-light-invoices',
  },
  queryParams: {
    [GET_LIGHT_INVOICES_QUERY_PARAM.name]: GET_LIGHT_INVOICES_QUERY_PARAM,
  },
  response: {
    name: 'GetLightInvoicesResponse',
    schema: GetLightInvoicesResponseSchema,
  },
  path: GET_LIGHT_INVOICES_PATH,
} satisfies ZapiAction;

export type GetLightInvoicesAction = typeof GET_LIGHT_INVOICES_ACTION;